import React, { useRef, useState } from 'react';
import CommonModal from '../../../Components/CommonModal';
import CommonButton from '../../../Components/CommonButton';
import { Body } from '../../../Constants/Fonts';


const REQUEST_TYPES = [
    { value: 'bug', label: 'Bug' },
    { value: 'feature', label: 'Feature' },
];

const ACCEPT = '.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.png,.jpg,.jpeg,.gif,.zip';
// Keep attachments small enough to survive being forwarded by email.
const MAX_FILE_MB = 10;
const MAX_FILE_BYTES = MAX_FILE_MB * 1024 * 1024;

export default function SupportRequestForm({ onSubmit, saving, error }) {
    const [files, setFiles] = useState([]);
    const [fileError, setFileError] = useState('');
    const fileRef = useRef(null);

    const selectFiles = (e) => {
        const picked = Array.from(e.target.files || []);
        e.target.value = '';
        const tooBig = picked.filter((f) => f.size > MAX_FILE_BYTES);
        const ok = picked.filter((f) => f.size <= MAX_FILE_BYTES);
        setFileError(tooBig.length ? `${tooBig.map((f) => f.name).join(', ')} — over ${MAX_FILE_MB} MB, not added` : '');
        if (ok.length) setFiles((prev) => [...prev, ...ok]);
    };
    const removeAt = (idx) => setFiles((prev) => prev.filter((_, i) => i !== idx));

    return (
        <CommonModal
            inline
            fullscreen='true'
            title="New Request"
            fields={[
                { name: 'request_type', label: 'Request Type', type: 'select', required: true, options: REQUEST_TYPES, placeholder: 'Select bug or feature' },
                {
                    name: 'description', label: 'Description', type: 'textarea', rows: 6, required: true,
                    placeholder: 'What happened, or what would you like to see? Include steps to reproduce for bugs.',
                    minLength: { value: 10, message: 'Please add a little more detail (at least 10 characters)' },
                },
            ]}
            defaultValues={{ request_type: '', description: '' }}
            onSubmit={(values) => onSubmit(values, files)}
            error={error}
            buttons={[
                { text: 'Submit Request', variant: 'primary', type: 'submit', loading: saving, loadingText: 'Submitting…' },
            ]}
        >
            <div className=" cmn-modal-field" style={{ marginTop: 14 }}>
                <label className="cmn-modal-label">Attachments</label>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <div>
                        <CommonButton type="button" variant="secondary" text={files.length ? 'Add More Files' : 'Upload Files'}
                            onClick={() => fileRef.current?.click()} disable={saving} />
                    </div>
                    {files.map((file, i) => (
                        <div key={`${file.name}-${file.size}-${i}`} style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                            <Body as="span" variant={2} color="var(--color-text-secondary)" style={{ wordBreak: 'break-all' }}>{file.name}</Body>
                            <CommonButton type="button" variant="error" text="Remove" onClick={() => removeAt(i)} disable={saving} />
                        </div>
                    ))}
                    <Body as="span" variant={2} color="var(--color-text-muted)">
                        Optional. Screenshots, logs or documents — up to {MAX_FILE_MB} MB each.
                    </Body>
                    <input ref={fileRef} type="file" multiple accept={ACCEPT} style={{ display: 'none' }} onChange={selectFiles} />
                </div>
                {fileError && <Body variant={2} color="var(--color-danger)" style={{ margin: '5px 0 0' }}>{fileError}</Body>}
            </div>
        </CommonModal>
    );
}
